import { Chip, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import clsx from "clsx";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import {
  getColumnControl,
  getFormattedData,
  getFormattedHeaders
} from "../../../utils/formatData";
import { cloneDeepHelper } from "../../../utils/helper";
import FullScreenDialog from "../Dialog/Dialog";
import "./Table.less";

/** Descending comparator function */
function descendingComparator(a, b, orderBy) {
  // if(isNaN(a[orderBy]) && isNaN(b[orderBy]))
  if (typeof a[orderBy] === "string" && typeof a[orderBy] === "string") {
    const lowerCaseB =
      b[orderBy] !== undefined && b[orderBy] !== null
        ? b[orderBy].toString().toLowerCase()
        : b[orderBy];
    const lowerCaseA =
      a[orderBy] !== undefined && a[orderBy] !== null
        ? a[orderBy].toString().toLowerCase()
        : a[orderBy];
    if (lowerCaseB < lowerCaseA) {
      return -1;
    }
    if (lowerCaseB > lowerCaseA) {
      return 1;
    }
  } else if (!isNaN(b[orderBy]) && !isNaN(a[orderBy])) {
    const numA = Number(a[orderBy]).toFixed(2);
    const numB = Number(b[orderBy]).toFixed(2);
    if (Number(numB) < Number(numA)) {
      return -1;
    }
    if (Number(numB) > Number(numA)) {
      return 1;
    }
  } else {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  }
  return 0;
}

/** Get values for compare */
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

/** create sorted table */
function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    headCells,
    headcellClass,
    config
  } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <>
      <TableHead style={{ top: props.topvalue + "px" }}>
        <TableRow>
          {(headCells || [])
            .filter(
              x =>
                x.showInEditOnly !== true &&
                (_.camelCase(x.type) !== _.camelCase("Child") ||
                  config.startFromBegining !== true)
            )
            .map((headCell, i) =>
              headCell.renderControls === undefined ? (
                <TableCell
                  key={headCell.key + headCell.keyTag ?? ""}
                  sortDirection={orderBy === headCell.key ? order : false}
                  className={
                    (headcellClass || "") +
                    (props.isSticky !== true ? " no-sticky" : "")
                  }
                  style={{
                    width:
                      (headCell.minWidth
                        ? headCell.minWidth
                        : (
                            props.updatedColumnsWidth.find(
                              x => x.key === headCell.key
                            ) || {}
                          ).width) + "px"
                  }}
                >
                  {headCell.renderComponent === undefined &&
                  config?.sorting !== false ? (
                    <TableSortLabel
                      active={orderBy === headCell.key}
                      style={{
                        // textTransform: 'capitalize',
                        paddingLeft:
                          i === 0 && config?.collapsible === true
                            ? "20px"
                            : undefined
                      }}
                      direction={orderBy === headCell.key ? order : "asc"}
                      onClick={createSortHandler(headCell.key)}
                    >
                      {getFormattedHeaders(headCell.name, headCell.dataFormat)}
                      {/* {orderBy === headCell.key
                    ? ( */}

                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                      {/* )
                    : null} */}
                    </TableSortLabel>
                  ) : (
                    <div
                      style={{
                        // textTransform: 'capitalize',
                        paddingRight: "4px"
                      }}
                    >
                      {getFormattedHeaders(
                        headCell.name,
                        headCell.renderComponent === undefined
                          ? headCell?.dataFormat
                          : "Text"
                      )}{" "}
                    </div>
                  )}
                </TableCell>
              ) : (
                headCell.renderControls !== undefined && (
                  <TableCell
                    key={headCell.key + headCell.keyTag ?? ""}
                    sortDirection={orderBy === headCell.key ? order : false}
                    className={
                      (headcellClass || "") +
                      (props.isSticky !== true ? " no-sticky" : "")
                    }
                    style={{
                      width:
                        (headCell.minWidth
                          ? headCell.minWidth
                          : (
                              props.updatedColumnsWidth.find(
                                x => x.key === headCell.key
                              ) || {}
                            ).width) + "px"
                    }}
                  >
                    {getColumnControl(
                      props.headerData,
                      headCell,
                      props.handleTableHeaderEditChange
                    )}
                  </TableCell>
                )
              )
            )}
        </TableRow>
      </TableHead>
      {props.isSticky && (
        <TableHead id={"staticHeader"} className={"normal-header"}>
          <TableRow>
            {(headCells || [])
              .filter(
                x =>
                  x.showInEditOnly !== true &&
                  (_.camelCase(x.type) !== _.camelCase("Child") ||
                    config.startFromBegining !== true)
              )
              .map(headCell => (
                <TableCell
                  key={"staticHeader" + headCell.key + headCell.keyTag ?? ""}
                  sortDirection={orderBy === headCell.key ? order : false}
                  className={headcellClass || ""}
                  style={{
                    width:
                      (
                        props.updatedColumnsWidth.find(
                          x => x.key === headCell.key
                        ) || {}
                      ).width + "px"
                  }}
                >
                  <div className={"col-xs-12"}>
                    <TableSortLabel
                      active={orderBy === headCell.key}
                      style={{
                        // textTransform: 'capitalize',
                        paddingLeft:
                          config.collapsible === true
                            ? "20px"
                            : undefined
                      }}
                      direction={orderBy === headCell.key ? order : "asc"}
                      onClick={createSortHandler(headCell.key)}
                    >
                      {getFormattedHeaders(headCell.name, headCell.dataFormat)}
                      {orderBy === headCell.key ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </div>
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
      )}
    </>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array,
  headcellClass: PropTypes.string,
  isSticky: PropTypes.bool,
  updatedColumnsWidth: PropTypes.array,
  topvalue: PropTypes.number
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  title: {
    flex: "1 1 100%"
  }
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color={"inherit"}
          variant={"subtitle1"}
          component={"div"}
        >
          {numSelected} {"selected\r"}
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant={"h6"}
          id={"tableTitle"}
          component={"div"}
        >
          {"Nutrition\r"}
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title={"Delete"}>
          <IconButton aria-label={"delete"}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={"Filter list"}>
          <IconButton aria-label={"filter list"}>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    marginTop: "5px"
  },
  paper: {
    width: "100%",
    marginBottom: "5px",
    marginTop: "5px"
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  }
}));

subGridTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  config: PropTypes.object,
  selectedEditRowId: PropTypes.object,
  isInAddMode: PropTypes.bool,
  EditSource: PropTypes.array,
  handleTableEditChange: PropTypes.func,
  onRowClick: PropTypes.func,
  isEditableMode: PropTypes.bool
};

/** sab grid table */
export default function subGridTable(props) {
  const {
    columns,
    data,
    config = {},
    selectedEditRowId,
    isInAddMode,
    EditSource
  } = props;
  const classes = useStyles();
  const [order, setOrder] = React.useState(config.order || "desc");
  const [orderBy, setOrderBy] = React.useState(
    config.orderBy || "lastModifiedOn"
  );
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [openTagDataDialogConfig, setOpenTagDataDialogConfig] = React.useState({
    openTagDataDialog: true,
    title: "",
    children: undefined
  });

  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [rowsPerPageOptions] = React.useState([5, 10, 25, 50]);
  const [showPager] = React.useState(
    (config || {}).showPager !== undefined ? config.showPager : true
  );

  /**
   * View tag data
   * @param {*} title 
   * @param {*} children 
   */
  const viewTagData = (title, children) => {
    setOpenTagDataDialogConfig({
      openTagDataDialog: true,
      title,
      children
    });
  };

  /**
   * close view tag data
   */
  const closeViewTagData = () => {
    setOpenTagDataDialogConfig({
      openTagDataDialog: false,
      title: "",
      children: undefined
    });
  };

  const [isSticky, setSticky] = useState(false);
  const [topValue, setTopValue] = useState(68);
  const [updatedColumnsWidth, setUpdatedColumnsWidth] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const ref = useRef(null);
  const handleScroll = () => {
    // console.log(ref);
    const colWidth = [];
    // console.log(columns);
    if (props.StickyHeader) {
      if (ref.current) {
        const top = ref.current.getBoundingClientRect().top;
        setSticky(ref.current.getBoundingClientRect().top <= 63);
        if (top <= 63) {
          data &&
            data.length > 0 &&
            columns.forEach((col, index) => {
              // console.log(col.name, col);
              const width =
                ref.current.children[0].children[2].children[0].children[index]
                  .clientWidth;
              colWidth.push({ key: col.key, width: width });
            });

          const val = (top > 0 ? top : top * -1) + (top > 0 ? top - 63 : 63);
          if (parseInt(top) !== parseInt(val)) {
            setTopValue(val > 0 ? val : 43);
          } else {
            setTopValue(43);
          }
          // console.log(top, "|", val);
        } else {
          setTopValue(undefined);
        }
        setUpdatedColumnsWidth(colWidth);

        // console.log(ref.current.getBoundingClientRect().top);
      }
    }
  };

  /**
   * function for effect
   */
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);

  useEffect(() => {
    setPage(0);
  }, [props.data]);

  useEffect(() => {
    setPage(page);
    setSelectedRow([]);
  }, [props.reload]);

  // useEffect(() => {
  //   setPage(0);
  // }, [props.EditSource]);

  /**
   * function to set sorting order
   * @param {*} event 
   * @param {*} property 
   */
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  /**
   * call on page change
   * @param {*} event 
   * @param {*} newPage 
   */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /**
   * call on change rows for each page
   * @param {*} event 
   */
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /**
   * get grouped data
   * @param {*} data 
   * @param {*} key 
   * @returns 
   */
  const getGroupedData = (data, key) => {
    // data = stableSort(
    //   stableSort(data, getComparator(order, orderBy)),
    //   getComparator(order, key)
    // );
    data = _.orderBy(
      data || [],
      [
        data =>
          data[orderBy] !== null &&
          data[orderBy] !== undefined &&
          isNaN(data[orderBy]) !== false
            ? moment(data[orderBy]).format("MM/DD/YYYY") !== "Invalid date"
              ? new Date(data[orderBy]).getTime()
              : data[orderBy].toString().toLowerCase()
            : data[orderBy]
      ],
      [order]
    );
    // if (Object.keys((data || [])[0] || {}).find(x => x === orderBy)) {
    //   data = stableSort(data, getComparator(order, orderBy));
    // }
    data.forEach(x => {
      x.groupByKey = (x[config.groupBy] || 0) + "Groupkey";
    });
    const groupedData = _.groupBy(data, function(da) {
      return da.groupByKey;
    });
    let orderGroupData = {};
    if (key === orderBy) {
      orderGroupData = Object.entries(groupedData).sort((a, b) =>
        order === "desc" ? b - a : a - b
      );
    } else {
      Object.entries(groupedData).forEach(rows => {
        const o = rows[1].sort(getComparator(order, orderBy));
        orderGroupData[rows[0]] = o;
      });
    }
    // Object.entries(groupedData)
    //   .sort(([, a], [, b]) => a - b)
    //   .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

    return orderGroupData;
  };

  /**
   * handle value change for table
   * @param {*} value 
   * @param {*} FieldName 
   * @param {*} row 
   * @param {*} addMode 
   * @param {*} index 
   */
  const handleTableValueChange = (value, FieldName, row, addMode, index) => {
    props.handleTableEditChange(value, FieldName, row, addMode, index);
  };

  return (
    <div className={classes.root}>
      {openTagDataDialogConfig.openTagDataDialog &&
        openTagDataDialogConfig.children && (
          <FullScreenDialog
            title={openTagDataDialogConfig.title}
            open={openTagDataDialogConfig.openTagDataDialog}
            close={() => {
              closeViewTagData("", undefined);
            }}
          >
            {openTagDataDialogConfig.children}
          </FullScreenDialog>
        )}
      <Paper className={classes.paper}>
        {props.AddNewRecord && props.AddNewRecord.visible && (
          <>
            {" "}
            <IconButton
              aria-label={"add-new-row"}
              className={"action-button"}
              size={"small"}
              onClick={() => {
                props.AddNewRecord.action();
              }}
              disabled={props.AddNewRecord.disableAddButton || false}
              // disabled
            >
              <AddIcon
                disabled={props.AddNewRecord.disableAddButton || false}
                fontSize={"small"}
                size={"small"}
              />
              <span className={"tool-icon-text"}>{props.AddNewRecord.title}</span>
            </IconButton>
            {props.additionalAction && props.additionalAction.visible && (
              <IconButton
                aria-label={"add-new-row"}
                className={"action-button"}
                size={"small"}
                onClick={() => {
                  props.additionalAction.action();
                }}

                // disabled
              >
                <AddIcon fontSize={"small"} size={"small"} />
                <span className={"tool-icon-text"}>
                  {props.additionalAction.title}
                </span>
              </IconButton>
            )}
            {/* <Button
            variant="contained"
                        aria-label={'add-new-row'}
                        className="action-button no-print"
                        size="small"
                        onClick={() => {
                          props.additionalAction.action();}}
                      >
                       <span className="tool-icon-text">{props.additionalAction.title}</span>
                      </Button> */}
          </>
        )}
        {showPager && !(config || {}).showBottomPagerOnly && (
          <>
            <TextField
              className={"pull-right page-number"}
              label={"Page No."}
              value={page + 1}
              onChange={event => {
                if ((event.target.value || "").toString() === "0") {
                  event.target.value = 1;
                }
                if (
                  config.pagerGrouping !== true &&
                  event.target.value - 1 * rowsPerPage <= (data || []).length
                ) {
                  setPage(event.target.value - 1);
                } else if (
                  config.pagerGrouping === true &&
                  event.target.value - 1 * rowsPerPage <=
                    Object.entries(getGroupedData(data || [])).length
                ) {
                  setPage(event.target.value - 1);
                }
              }}
              margin={"normal"}
              variant={"standard"}
            />
          </>
        )}
        <TableContainer
          className={`sticky-wrapper${isSticky ? " sticky" : ""}`}
          ref={ref}
        >
          <Table
            id={"gridTable"}
            stickyHeader
            className={classes.table}
            aria-labelledby={"tableTitle"}
            size={dense ? "small" : "medium"}
            aria-label={"sticky table"}
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              rowCount={(data || []).length}
              onRequestSort={handleRequestSort}
              headCells={columns}
              headcellClass={config.headcellClass}
              isSticky={isSticky}
              topvalue={topValue}
              updatedColumnsWidth={updatedColumnsWidth}
              config={config}
              {...props}
            />
            {(config === undefined ||
              (config.collapsibleMultilevel !== true &&
                config.collapsible !== true &&
                config.inLineGroupBlock !== true)) && (
              <TableBody>
                {isInAddMode && (
                  <TableRow
                    className={
                      config.oddRowClass || "oddRow add"
                    }
                    key={"pager-false-table_data_add" + 0}
                  >
                    {}
                    {renderRow(
                      isInAddMode,
                      0,
                      columns,
                      props,
                      props.updateData,
                      EditSource,
                      selectedEditRowId,
                      updatedColumnsWidth,
                      handleTableValueChange,
                      viewTagData
                    )}
                  </TableRow>
                )}
                {showPager &&
                  _.orderBy(
                    data || [],
                    [
                      data =>
                        data[orderBy] !== null &&
                        data[orderBy] !== undefined &&
                        isNaN(data[orderBy]) !== false
                          ? moment(data[orderBy]).format("MM/DD/YYYY") !==
                            "Invalid date"
                            ? new Date(data[orderBy]).getTime()
                            : (data[orderBy] || "").toString().toLowerCase()
                          : data[orderBy] || ""
                    ],
                    [order]
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          className={
                            index % 2 === 0
                              ? config.evenRowClass || " evenRow"
                              : config.oddRowClass || " oddRow"
                          }
                          key={"table_data" + index}
                        >
                          {renderRow(
                            isInAddMode,
                            index,
                            columns,
                            props,
                            row,
                            EditSource,
                            selectedEditRowId,
                            updatedColumnsWidth,
                            handleTableValueChange,
                            viewTagData
                          )}
                        </TableRow>
                      );
                    })}
                {showPager === false &&
                  _.orderBy(
                    data || [],
                    [
                      data =>
                        data[orderBy] !== null &&
                        data[orderBy] !== undefined &&
                        isNaN(data[orderBy]) !== false
                          ? moment(data[orderBy]).format("MM/DD/YYYY") !==
                            "Invalid date"
                            ? new Date(data[orderBy]).getTime()
                            : data[orderBy].toString().toLowerCase()
                          : data[orderBy]
                    ],
                    [order]
                  ).map((row, index) => {
                    return (
                      <TableRow
                        className={
                          index % 2 === 0
                            ? config.evenRowClass || "evenRow"
                            : config.oddRowClass || "oddRow"
                        }
                        key={"pager-false-table_data" + index}
                      >
                        {renderRow(
                          isInAddMode,
                          index,
                          columns,
                          props,
                          row,
                          EditSource,
                          selectedEditRowId,
                          updatedColumnsWidth,
                          handleTableValueChange,
                          viewTagData
                        )}
                      </TableRow>
                    );
                  })}
                {(data || []) === [] ||
                  ((data || []).length === 0 && (
                    <TableRow
                      key={"emptyRow"}
                      style={{ height: dense ? 33 : 53 }}
                    >
                      <TableCell
                        key={"emptyRowCell"}
                        colSpan={
                          (
                            (columns || []).filter(
                              x => x.showInEditOnly !== true
                            ) || []
                          ).length
                        }
                      >
                        {isInAddMode ? "" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ))}
                {showPager &&
                  (data || []).length > 0 &&
                  _.orderBy(
                    data || [],
                    [
                      data =>
                        data[orderBy] !== null &&
                        data[orderBy] !== undefined &&
                        isNaN(data[orderBy]) !== false
                          ? moment(data[orderBy]).format("MM/DD/YYYY") !==
                            "Invalid date"
                            ? new Date(data[orderBy]).getTime()
                            : (data[orderBy] || "").toString().toLowerCase()
                          : data[orderBy] || ""
                    ],
                    [order]
                  ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .length === 0 && (
                    <TableRow
                      key={"emptyRow"}
                      style={{ height: dense ? 33 : 53 }}
                    >
                      <TableCell
                        key={"emptyRowCell"}
                        colSpan={
                          (
                            (columns || []).filter(
                              x => x.showInEditOnly !== true
                            ) || []
                          ).length
                        }
                      >
                        {isInAddMode ? "" : "No data available"}
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            )}
            {config.collapsibleMultilevel !== true &&
              config.collapsible !== true &&
              config.inLineGroupBlock === true && (
                <TableBody>
                  {isInAddMode && (
                    <TableRow
                      className={config.oddRowClass || "oddRow add"}
                      key={"pager-false-table_data_add" + 0}
                    >
                      {renderRow(
                        isInAddMode,
                        0,
                        columns,
                        props,
                        props.updateData,
                        EditSource,
                        selectedEditRowId,
                        updatedColumnsWidth,
                        handleTableValueChange,
                        viewTagData
                      )}
                    </TableRow>
                  )}
                  {showPager &&
                    Object.entries(getGroupedData(data || []))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((rows, pIndex) =>
                        rows[1].map((row, index) => {
                          return (
                            <TableRow
                              className={
                                pIndex % 2 === 0
                                  ? config.evenRowClass || " evenRow"
                                  : config.oddRowClass || " oddRow"
                              }
                              key={"table_data" + index}
                              onClick={() => {
                                props.onRowClick && props.onRowClick(row);
                              }}
                            >
                              {renderRow(
                                isInAddMode,
                                index,
                                columns,
                                props,
                                row,
                                EditSource,
                                selectedEditRowId,
                                updatedColumnsWidth,
                                handleTableValueChange,
                                viewTagData
                              )}
                            </TableRow>
                          );
                        })
                      )}
                  {showPager === false &&
                    Object.entries(getGroupedData(data || [])).map(
                      (rows, pIndex) =>
                        rows[1].map((row, index) => {
                          return (
                            <TableRow
                              className={
                                pIndex % 2 === 0
                                  ? config.evenRowClass || "evenRow"
                                  : config.oddRowClass || "oddRow"
                              }
                              key={"pager-false-table_data" + index}
                            >
                              {renderRow(
                                isInAddMode,
                                index,
                                columns,
                                props,
                                row,
                                EditSource,
                                selectedEditRowId,
                                updatedColumnsWidth,
                                handleTableValueChange,
                                viewTagData
                              )}
                            </TableRow>
                          );
                        })
                    )}
                  {(data || []) === [] ||
                    ((data || []).length === 0 && (
                      <TableRow
                        key={"emptyRow"}
                        style={{ height: dense ? 33 : 53 }}
                      >
                        <TableCell
                          key={"emptyRowCell"}
                          colSpan={
                            (
                              (columns || []).filter(
                                x => x.showInEditOnly !== true
                              ) || []
                            ).length
                          }
                        >
                          {isInAddMode ? "" : "No data available"}
                        </TableCell>
                      </TableRow>
                    ))}
                  {showPager &&
                    (data || []).length > 0 &&
                    Object.entries(getGroupedData(data || [])).slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).length === 0 && (
                      <TableRow
                        key={"emptyRow"}
                        style={{ height: dense ? 33 : 53 }}
                      >
                        <TableCell
                          key={"emptyRowCell"}
                          colSpan={
                            (
                              (columns || []).filter(
                                x => x.showInEditOnly !== true
                              ) || []
                            ).length
                          }
                        >
                          {isInAddMode ? "" : "No data available"}
                        </TableCell>
                      </TableRow>
                    )}
                  {/* {showPager && emptyRows > 0 && (
                  <TableRow
                    key="emptyRow1"
                    style={{ height: (dense ? 33 : 53) * emptyRows }}
                  >
                    <TableCell key="emptyRowCell1" colSpan={6} />
                  </TableRow>
                )} */}
                </TableBody>
              )}
            {config.collapsibleMultilevel && (
              <TableBody>
                <CollapsibleMultilevel
                  {...props}
                  handleTableValueChange={handleTableValueChange}
                  selectedRow={selectedRow}
                  setSelectedRow={setSelectedRow}
                  tdata={_.orderBy(
                    data || [],
                    [
                      data =>
                        data[orderBy] !== null &&
                        data[orderBy] !== undefined &&
                        isNaN(data[orderBy]) !== false
                          ? moment(data[orderBy]).format("MM/DD/YYYY") !==
                            "Invalid date"
                            ? new Date(data[orderBy]).getTime()
                            : data[orderBy].toString().toLowerCase()
                          : data[orderBy]
                    ],
                    [order]
                  )}
                />
                {(data || []).length === 0 && (
                  <TableRow key={"emptyRow1"} style={{ height: dense ? 33 : 53 }}>
                    <TableCell
                      key={"emptyRowCell1"}
                      colSpan={
                        (
                          (columns || []).filter(
                            x => x.showInEditOnly !== true
                          ) || []
                        ).length
                      }
                    >
                      {/* No data available */}
                      {isInAddMode ? "" : "No data available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
            {config.collapsible && (
              <TableBody>
                {Object.entries(getGroupedData(data || []))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((obj, index) => (
                    <CollapsableRow
                      key={obj[0]}
                      isInAddMode={isInAddMode}
                      EditSource={EditSource}
                      selectedEditRowId={selectedEditRowId}
                      row={obj[1]}
                      columns={columns}
                      config={config}
                      index={index}
                      updatedColumnsWidth={updatedColumnsWidth}
                      {...props}
                      viewTagData={viewTagData}
                    />
                  ))}
                {(data || []).length === 0 && (
                  <TableRow key={"emptyRow1"} style={{ height: dense ? 33 : 53 }}>
                    <TableCell
                      key={"emptyRowCell1"}
                      colSpan={
                        (
                          (columns || []).filter(
                            x => x.showInEditOnly !== true
                          ) || []
                        ).length
                      }
                    >
                      {isInAddMode ? "" : "No data available"}
                    </TableCell>
                  </TableRow>
                )}
                {showPager &&
                  (data || []).length > 0 &&
                  Object.entries(getGroupedData(data || [])).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  ).length === 0 && (
                    <TableRow
                      key={"emptyRow"}
                      style={{ height: dense ? 33 : 53 }}
                    >
                      <TableCell
                        key={"emptyRowCell"}
                        colSpan={
                          (
                            (columns || []).filter(
                              x => x.showInEditOnly !== true
                            ) || []
                          ).length
                        }
                      >
                        {isInAddMode ? "" : "No data available"}
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {showPager && !(config || {}).showTopPagerOnly && (
          <>
            <TextField
              className={"pull-right page-number"}
              label={"Page No."}
              value={page + 1}
              onChange={event => {
                if (
                  config.pagerGrouping !== true &&
                  event.target.value - 1 * rowsPerPage <= (data || []).length
                ) {
                  setPage(event.target.value - 1);
                } else if (
                  config.pagerGrouping === true &&
                  event.target.value - 1 * rowsPerPage <=
                    Object.entries(getGroupedData(data || [])).length
                ) {
                  setPage(event.target.value - 1);
                }
              }}
              margin={"normal"}
              variant={"standard"}
            />
            <TablePagination
              labelRowsPerPage={"Rows Per Page"}
              key={"bottom-Pagination"}
              className={"pager"}
              rowsPerPageOptions={rowsPerPageOptions}
              component={"div"}
              // count={config.pagerGrouping !== true ? (data || []).length : Object.entries(getGroupedData(data || [])).length}
              count={(data || []).length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>
    </div>
  );
}

export const GridTable = React.memo(subGridTable);
const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset"
    }
  }
});

const CollapsibleMultilevel = props => {
  const {
    config,
    columns,
    isInAddMode,
    EditSource,
    selectedEditRowId,
    updatedColumnsWidth,
    handleTableValueChange,
    viewTagData,
    tdata,
    selectedRow,
    setSelectedRow
  } = props;

  /** call on collapsible change */
  const handelCollapsibleChange = (key, value, isOpen) => {
    const selectedRows = _.cloneDeep(
      (selectedRow || []).filter(x => !(x.key === key && x.value === value))
    );
    selectedRows.push({ key: key, value: value, isOpen: isOpen });
    setSelectedRow(selectedRows);
    props.handleTableEditChange("");
  };

  /** set according to filter value for group */
  const getGroupValues = (data, key, groupBy, primaryKey) => {
    groupBy = groupBy.filter(x => x !== key);
    const nextKey = groupBy[0];
    return _.chain(data)
      .groupBy(key)
      .map(function(v, i) {
        return {
          key: key,
          [key]: i === "null" ? "Unknown" : i,
          indexKey: ((v || [])[0] || {})[primaryKey || ""] || "" + key + i,
          marketId: ((v || [])[0] || {}).marketId,
          isReimbursedExceed: (v || []).find(x => x.isReimbursedExceed === true)
            ?.isReimbursedExceed,
          data:
            nextKey !== undefined
              ? getGroupValues(v, nextKey, groupBy, primaryKey)
              : v,
          variance: _.sumBy(v, function(el) {
            return el.variance;
          }),
          preferredName: (v || []).length,
          propertyBillingPercent: _.sumBy(v || [], function(el) {
            return el.propertyBillingPercent || 0;
          }),
          propertyAllocationPercent: _.sumBy(v || [], function(el) {
            return el.propertyAllocationPercent || 0;
          }),
          marketAllocationPercent: _.sumBy(v || [], function(el) {
            return el.marketAllocationPercent || 0;
          }),
          reimbursement: _.sumBy(v || [], function(el) {
            return el.reimbursement;
          }),
          reimburse: _.sumBy(v || [], function(el) {
            return el.reimburse;
          }),
          priorPeriodReimburse: _.sumBy(v || [], function(el) {
            return el.priorPeriodReimburse;
          }),
          variancePercent: v
            ? (_.sumBy(v || [], function(el) {
                return el.variance || 0;
              }) /
                _.sumBy(v || [], function(el) {
                  return el.priorPeriodReimburse || 0;
                })) *
              100
            : 0
        };
      })
      .value();
  };

  /** fetch multilevel group data */
  const getMultilevelGroupedData = () => {
    let groupedData = _.cloneDeep(tdata);
    if (config.groupBy !== undefined) {
      // console.log(groupedData, config.groupBy[0], config.groupBy, config.primaryKey);
      groupedData = getGroupValues(
        groupedData,
        config.groupBy[0],
        config.groupBy,
        config.primaryKey,
        "marketId"
      );
    }
    return renderTableCell(groupedData);
  };

  /** fill cell data */
  const renderTableCell = (
    groupedData,
    keyvalue = [],
    tableCell = [],
    rowCount = 0
  ) => {
    groupedData.forEach(d => {
      if (d.key && d[d.key]) {
        keyvalue.push({ key: d.key, value: d[d.key] });
      }
      const row = cloneDeepHelper(d);
      const selected = (selectedRow || []).find(
        x =>
          x.key === d.key &&
          x.value === d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
      )
        ? (selectedRow || []).find(
            x =>
              x.key === d.key &&
              x.value ===
                d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
          )
        : props.expand === true
        ? (selectedRow || []).find(
            x =>
              x.key === d.key &&
              x.value ===
                d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
          )
          ? (selectedRow || []).find(
              x =>
                x.key === d.key &&
                x.value ===
                  d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
            )
          : {
              key: d.key,
              value: d[d.key] + d.marketId?.toString() + d.indexKey?.toString(),
              isOpen: true
            }
        : props.expand === true &&
          (selectedRow || []).find(
            x =>
              x.key === d.key &&
              x.value ===
                d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
          ) === undefined
        ? {
            key: d.key,
            value: d[d.key] + d.marketId?.toString() + d.indexKey?.toString(),
            isOpen: true
          }
        : // : props.expand === true &&
          // props.filterOnExpand === true
          //   ? { key: d.key, value: d[d.key] + d.marketId?.toString(), isOpen: true }
          //   : props.filterOnExpand === true
          //     ? { key: d.key, value: d[d.key] + d.marketId?.toString(), isOpen: true }
          (selectedRow || []).find(
            x =>
              x.key === d.key &&
              x.value ===
                d[d.key] + d.marketId?.toString() + d.indexKey?.toString()
          ) || {
            key: d.key,
            value: d[d.key] + d.marketId?.toString() + d.indexKey?.toString(),
            isOpen: false
          };
      ((config || {}).groupBy || []).forEach(key => {
        if (key !== d.key) {
          delete row[key];
        }
      });
      row.indexKey = d.indexKey?.toString();
      const rowClass =
        rowCount % 2 === 0
          ? (config || {}).evenRowClass || " evenRow"
          : (config || {}).oddRowClass || " oddRow";

      // rowClass += row.isReimbursedExceed === true
      //   ? ' exceed'
      //   : '';

      if (
        props.hideChildRowWhen === undefined ||
        props.hideChildRowWhen.apply !== true ||
        row[props.hideChildRowWhen.key] !== props.hideChildRowWhen.value
      ) {
        tableCell.push(
          <TableRow
            className={rowClass}
            // key={'table_data' + rowCount + d.indexKey + d[config.primaryKey] + d[d.key]}
          >
            {renderRow(
              isInAddMode,
              rowCount,
              columns,
              props,
              row,
              EditSource,
              selectedEditRowId,
              updatedColumnsWidth,
              handleTableValueChange,
              viewTagData,
              d.data !== undefined,
              handelCollapsibleChange,
              selected
            )}
          </TableRow>
        );
        rowCount++;
      }
      if (d.data !== undefined && (selected || {}).isOpen) {
        renderTableCell(d.data, keyvalue, tableCell, rowCount);
      }
    });
    return tableCell;
  };

  return <React.Fragment>{getMultilevelGroupedData()}</React.Fragment>;
};

const CollapsableRow = props => {
  const {
    columns,
    config,
    index,
    isInAddMode,
    EditSource,
    selectedEditRowId,
    viewTagData
  } = props;
  let { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  let addExtraSpace = false;
  if (config.groupOrderBy) {
    row = _.orderBy(row, [config.groupOrderBy], ["asc"]);
  }
  if (config.appendText && config.appendText.field) {
    row.forEach(e => {
      if (config.appendText.where) {
        if (
          (e[config.appendText.where.key] || "").toString() ===
          config.appendText.where?.value?.toString()
        ) {
          if (
            e[config.appendText.field].indexOf("(CIO") < 0 &&
            row.length > 1
          ) {
            e[config.appendText.field] =
              e[config.appendText.field] + " (" + config.appendText.value + ")";
          }
        }
      } else {
        if (e[config.appendText.field].indexOf("(CIO") < 0 && row.length > 1) {
          e[config.appendText.field] =
            e[config.appendText.field] + " (" + config.appendText.value + ")";
        }
      }
    });
  }
  // if (config.addExtraSpace !== undefined) {
  //   if (config.addExtraSpace.key !== undefined) {
  //     if ((row[0] || {})[config.addExtraSpace.key] > config.addExtraSpace.whenGreaterThan) {
  //       addExtraSpace = true;
  //     }
  //   }
  // }
  let ignoreLength = false;
  if (config.ignoreLength === true) {
    ignoreLength = true;
  }
  if (config.addExtraSpace !== undefined) {
    if (config.addExtraSpace.key !== undefined) {
      if (
        (row[0] || {})[config.addExtraSpace.key] >
          config.addExtraSpace.whenGreaterThan ||
        ignoreLength
      ) {
        addExtraSpace = true;
      }
    }
  }

  return (
    <React.Fragment>
      <TableRow
        className={
          classes.root +
          (index % 2 === 0
            ? (props.onRowClick !== undefined ? " clickable " : " ") +
              (config.evenRowClass || "evenRow")
            : (props.onRowClick !== undefined ? " clickable " : " ") +
              (config.oddRowClass || "oddRow"))
        }
        onClick={() => {
          props.onRowClick && props.onRowClick(row[0]);
        }}
      >
        {(
          (columns || []).filter(
            x =>
              _.camelCase(x.type) !== _.camelCase("Child") ||
              config.startFromBegining !== true
          ) || []
        ).map((col, i) => (
          <TableCell
            key={"tableRowCell_parent" + index + i + col.key}
            style={{
              width:
                (props.updatedColumnsWidth.find(x => x.key === col.key) || {})
                  .width + "px"
            }}
          >
            <div className={"row"}>
              {/* {i === 0 && config.showCollapsible !== 'end' && ( */}
              {/* {<IconButton */}
              {i === 0 &&
                (row.length > 1 ||
                  config.showEqualSpace === true ||
                  ignoreLength) &&
                config.showCollapsible !== "end" && (
                  <div
                    className={
                      addExtraSpace ? "col-xs-2 addExtraSpace" : "col-xs-2"
                    }
                    style={{ paddingLeft: "0px" }}
                  >
                    {(row.length > 1 || ignoreLength) && (
                      <IconButton
                        key={col.key + i + row[col.key]}
                        aria-label={"expand row"}
                        size={"small"}
                        style={{ padding: "0px" }}
                        onClick={e => {
                          e.stopPropagation();
                          setOpen(!open);
                        }}
                      >
                        {open ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    )}
                  </div>
                )}

              <div
                className={
                  i === 0
                    ? addExtraSpace
                      ? "col-xs-10 addExtraSpace marginTop4"
                      : "col-xs-10 marginTop4"
                    : "col-xs-12 no-padding"
                }
              >
                {col.type === "Parent" || config.inLineGroupBlock === true ? (
                  col.renderComponent !== undefined ? (
                    props[col.renderComponent] &&
                    props[col.renderComponent](row[0], col.key, isInAddMode)
                  ) : row[0][col.key] === null ? (
                    "-"
                  ) : (
                    getFormattedData(
                      row[0],
                      col,
                      isInAddMode,
                      EditSource,
                      selectedEditRowId,
                      null,
                      false,
                      props,
                      undefined,
                      viewTagData
                    )
                  )
                ) : (
                  <></>
                )}
              </div>
              {i === 0 &&
                (row.length > 1 || config.showEqualSpace === true) &&
                config.showCollapsible === "end" && (
                  <div
                    className={
                      addExtraSpace ? "col-xs-4 addExtraSpace" : "col-xs-4"
                    }
                  >
                    {row.length > 1 && (
                      <IconButton
                        key={col.key + i + row[col.key]}
                        aria-label={"expand row"}
                        size={"small"}
                        onClick={e => {
                          e.stopPropagation();
                          setOpen(!open);
                        }}
                      >
                        {open ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    )}
                  </div>
                )}
            </div>
          </TableCell>
        ))}
      </TableRow>
      {open && (
        <>
          {config.startFromBegining !== true ? (
            row.map(
              (rowData, ir) =>
                (config.inLineGroupBlock !== true || ir !== 0) && (
                  <TableRow key={"rowData" + ir}>
                    {(columns || []).map((col, i) => (
                      <TableCell
                        key={"tableRowCell_child" + index + i + col.key}
                        style={{
                          width:
                            (
                              props.updatedColumnsWidth.find(
                                x => x.key === col.key
                              ) || {}
                            ).width + "px"
                        }}
                      >
                        <div className={"row"}>
                          {i === 0 && <div className={"col-xs-4"}> &nbsp;</div>}

                          <div className={i === 0 ? "col-xs-8" : "col-xs-12"}>
                            {(col.type === "Child" ||
                              config.inLineGroupBlock === true) &&
                            (col.editConfig === undefined ||
                              isHidden(rowData, col)) ? (
                              col.renderComponent !== undefined ? (
                                props[col.renderComponent] &&
                                props[col.renderComponent](
                                  rowData,
                                  col.key,
                                  isInAddMode
                                )
                              ) : (
                                getFormattedData(
                                  rowData,
                                  col,
                                  isInAddMode,
                                  EditSource,
                                  selectedEditRowId,
                                  null,
                                  false,
                                  props,
                                  undefined,
                                  viewTagData
                                )
                              )
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                )
            )
          ) : (
            <>
              <TableRow key={"ChildContainerRowData"} col>
                <TableCell colSpan={(columns || []).length}>
                  <Table
                    className={classes.table}
                    aria-labelledby={"tableTitle"}
                    size={"small"}
                    aria-label={"sticky table"}
                    // style={{width: '500px'}}
                  >
                    <TableHead>
                      <TableRow>
                        {(
                          (columns || []).filter(
                            x => _.camelCase(x.type) === _.camelCase("Child")
                          ) || []
                        ).map((col, i) => (
                          <TableCell
                            key={"tableRowCell_child" + index + i + col.key}
                            style={{
                              width:
                                (
                                  props.updatedColumnsWidth.find(
                                    x => x.key === col.key
                                  ) || {}
                                ).width + "px"
                            }}
                          >
                            <div className={"row"}>{col.name}</div>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    {row.map((rowData, ir) => (
                      <TableRow key={"rowData"}>
                        {(
                          (columns || []).filter(
                            x => _.camelCase(x.type) === _.camelCase("Child")
                          ) || []
                        ).map(col => (
                          <TableCell
                            key={"tableRowCell_child" + index + ir + col.key}
                            style={{
                              width:
                                (
                                  props.updatedColumnsWidth.find(
                                    x => x.key === col.key
                                  ) || {}
                                ).width + "px"
                            }}
                          >
                            <div className={"row"}>
                              <div className={"col-xs-12"}>
                                {(col.type === "Child" ||
                                  config.inLineGroupBlock === true) &&
                                (col.editConfig === undefined ||
                                  isHidden(rowData, col)) ? (
                                  col.renderComponent !== undefined ? (
                                    props[col.renderComponent] &&
                                    props[col.renderComponent](
                                      rowData,
                                      col.key,
                                      isInAddMode
                                    )
                                  ) : (
                                    getFormattedData(
                                      rowData,
                                      col,
                                      isInAddMode,
                                      EditSource,
                                      selectedEditRowId,
                                      null,
                                      false,
                                      props,
                                      undefined,
                                      viewTagData
                                    )
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </Table>
                </TableCell>
              </TableRow>
            </>
          )}
        </>
      )}
    </React.Fragment>
  );
};

CollapsableRow.propTypes = {
  row: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onRowClick: PropTypes.func,
  isInAddMode: PropTypes.bool,
  EditSource: PropTypes.array,
  handleTableEditChange: PropTypes.func,
  updatedColumnsWidth: PropTypes.array,
  selectedEditRowId: PropTypes.object
};
function isHidden(row, col) {
  let isValid = true;
  if (
    col.editConfig.hideWhen !== undefined &&
    col.editConfig.hideWhen.length > 0
  ) {
    col.editConfig.hideWhen.forEach(x => {
      isValid = row[x.key] !== x.value;
      if (!isValid) return false;
    });
  } else if (col.editConfig.isHidden !== undefined) {
    return !col.editConfig.isHidden;
  }
  return isValid;
}
function renderRow(
  isInAddMode,
  index,
  columns,
  props,
  row,
  EditSource,
  selectedEditRowId,
  updatedColumnsWidth,
  handleTableValueChange,
  viewTagData,
  showCollapsible,
  handelCollapsible,
  selected,
  isEditableMode = false
) {
  const editableClass = isEditableMode ? "edit-mode" : "";

  // const exceedColumn = (columns || []).filter(x => x.markRedOrGreen === true);
  // const markRedOrGreen = exceedColumn.map(x => x.markRedOrGreen);
  let exceededClass = " notexceeded";
  if (row.isReimbursedExceed !== undefined) {
    exceededClass =
      row.isReimbursedExceed === true ? " exceeded" : " notexceeded";
  }
  return selectedEditRowId &&
    selectedEditRowId.value === row[selectedEditRowId.key] &&
    props.isInline !== true ? (
    <TableCell
      key={"tableRowCell" + index + isInAddMode.toString()}
      colSpan={
        ((columns || []).filter(x => x.showInEditOnly !== true) || []).length
      }
      className={editableClass}
    >
      <div className={"row"} style={{ width: "100vw" }}>
        <div className={"col-xs-10"}>
          <div className={"row"}>
            {_.orderBy(columns || [], ["editSortOrder"], ["asc"]).map(
              (col, i) => (
                <>
                  {col.renderComponent === undefined &&
                    (col.editConfig === undefined ||
                      isHidden(props.updateData, col)) && (
                      <div
                        className={"col-xs-12 col-lg-4"}
                        style={{ marginTop: "10px" }}
                        key={"edit-" + i + col.key}
                      >
                        {getFormattedData(
                          props.updateData,
                          col,
                          isInAddMode,
                          EditSource,
                          selectedEditRowId,
                          handleTableValueChange,
                          true,
                          props,
                          index,
                          viewTagData
                        )}
                      </div>
                    )}
                  {col.dynamicRenderForm !== undefined &&
                    props.updateData[col.dynamicRenderForm] !== undefined &&
                    props.updateData[col.dynamicRenderForm].length > 0 && (
                      <>
                        <br />
                        <br /> {props.renderDynamicForm(props.updateData)}{" "}
                      </>
                    )}
                </>
              )
            )}
          </div>
        </div>
        <div className={"col-xs-1 center-xs"}>
          {(columns || []).map(col =>
            col.renderComponent !== undefined ? (
              props[col.renderComponent] &&
              props[col.renderComponent](row, col.key, isInAddMode)
            ) : (
              <></>
            )
          )}
        </div>
      </div>
    </TableCell>
  ) : (
    (columns || [])
      .filter(x => x.showInEditOnly !== true)
      .map((col, i) => (
        <TableCell
          className={col.markRedOrGreen === true ? exceededClass : ""}
          key={"tableRowCell" + index + i + col.key}
          style={{
            width: columns.width
              ? columns.width + "px"
              : ((updatedColumnsWidth || []).find(x => x.key === col.key) || {})
                  .width + "px"
          }}
        >
          {i === 0 &&
            props.rowBadge &&
            row[props.rowBadge.key] === props.rowBadge.equalsTo && (
              <Chip
                className={props.rowBadge.class}
                size={"small"}
                label={props.rowBadge.title}
              />
            )}
          {col.renderComponent !== undefined
            ? showCollapsible !== true &&
              props[col.renderComponent] &&
              props[col.renderComponent](row, col.key, isInAddMode)
            : getFormattedData(
                selectedEditRowId &&
                  selectedEditRowId.value === row[selectedEditRowId.key]
                  ? props.updateData
                  : row,
                col,
                isInAddMode,
                EditSource,
                selectedEditRowId,
                handleTableValueChange,
                false,
                props,
                undefined,
                viewTagData,
                showCollapsible,
                handelCollapsible,
                selected
              )}
        </TableCell>
      ))
  );
}
